import { useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';
import type { User } from '../types';

interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
}

const LOGIN_URL =
  (import.meta.env.VITE_LOGIN_URL as string | undefined) ||
  'https://studio.hub-platform.com/auth/login';

export function useAuth(): AuthState & { redirectToLogin: () => void } {
  const [state, setState] = useState<AuthState>({
    user: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    api
      .getMe()
      .then((user) => {
        if (!cancelled) setState({ user, loading: false, error: null });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const status = err instanceof ApiError ? err.status : 0;
        setState({
          user: null,
          loading: false,
          error: status === 401 ? 'unauthenticated' : String(err),
        });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const redirectToLogin = () => {
    const returnTo = encodeURIComponent(window.location.href);
    window.location.href = `${LOGIN_URL}?returnTo=${returnTo}`;
  };

  return { ...state, redirectToLogin };
}
